"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    OverflowContext: ()=>OverflowContext,
    useOverflowContext: ()=>useOverflowContext
});
const _reactContextSelector = require("@fluentui/react-context-selector");
const OverflowContext = /*#__PURE__*/ (0, _reactContextSelector.createContext)(undefined);
const overflowContextDefaultValue = {
    itemVisibility: {},
    groupVisibility: {},
    hasOverflow: false,
    registerItem: ()=>()=>null,
    updateOverflow: ()=>null,
    registerOverflowMenu: ()=>()=>null
};
const useOverflowContext = (selector)=>(0, _reactContextSelector.useContextSelector)(OverflowContext, (ctx = overflowContextDefaultValue)=>selector(ctx)); //# sourceMappingURL=overflowContext.js.map

//# sourceMappingURL=overflowContext.js.map